export const FETCH_VERIFIED_EMAIL_ADDRESSES = '@@firedrum/FETCH_VERIFIED_EMAIL_ADDRESSES'
export const FETCHING_VERIFIED_EMAIL_ADDRESSES = '@@firedrum/FETCHING_VERIFIED_EMAIL_ADDRESSES'
export const SET_VERIFIED_EMAIL_ADDRESSES = '@@firedrum/SET_VERIFIED_EMAIL_ADDRESSES'
export const VERIFY_EMAIL_ADDRESS = '@@firedrum/VERIFY_EMAIL_ADDRESS'
export const VERIFYING_EMAIL_ADDRESS = '@@firedrum/VERIFYING_EMAIL_ADDRESS'
